import './link.scss'
import { Link, LinkProps, useMatch, useResolvedPath } from 'react-router-dom'
import clx from 'classnames'

export const CustomLink = ({ children, to, ...props }: LinkProps) => {
    const resolved = useResolvedPath(to)
    const match = useMatch({ path: resolved.pathname, end: true })

    const routerClass = clx({
        'a-link__all': true,
        'a-link--active': match
    })

    return (
        <nav className='a-link'>
            <Link className={routerClass} to={to} {...props}>
                {children}
            </Link>
        </nav>
    )
}
